import { Text } from "react-konva";
import { useTranslation } from "react-i18next";

type WeekEndCanvasTextprops = {
  canvasWidth: number;
  canvasHeight: number;
  WeekEnd: string[];
  DowTasks: string[];
  weekFontSize: number;
  weekEndTaskY: number;
  fontFamilyName: string;
  weekEndY: number;
};

const WeekEndCanvasText: React.FC<WeekEndCanvasTextprops> = ({
  canvasWidth,
  canvasHeight,
  WeekEnd,
  DowTasks,
  weekFontSize,
  weekEndTaskY,
  weekEndY,
  fontFamilyName,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {WeekEnd.map((value: any, index: number /*土日タスク部分*/) => (
        <Text
          key={index + 5}
          fontSize={canvasWidth / 29}
          x={canvasWidth / 1.777 + index * (canvasWidth / 4.2)}
          y={canvasHeight / weekEndTaskY}
          width={canvasWidth / 5.5}
          text={DowTasks[index + 5]}
          fill="white"
          fontFamily={fontFamilyName}
        />
      ))}

      {WeekEnd.map((value: any, index: any /*土日表示部分*/) => (
        <Text
          key={index}
          fontSize={canvasWidth / weekFontSize}
          x={canvasWidth / 1.777 + index * (canvasWidth / 4.5714)}
          y={weekEndY}
          text={t("image.weekEndArr", { returnObjects: true })[index]}
          fill="#4b4b4b"
          fontFamily={fontFamilyName}
        />
      ))}
    </>
  );
};

export default WeekEndCanvasText;
